import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { PicklistService } from "../services/administration/picklist/picklist.service";
import { FireDepartmentsBcTurnoversService } from "../services/firedepartments/fireDepartmentsBcTurnovers.service";
import {
  IFireDepartmentBcTurnover,
  PumpStatus,
  TurnoverStatus,
} from "../interfaces/firedepartment-bc-turnover/firedepartmentBcTurnover";
import { Router } from "@angular/router";
import { IPicklistValuesData } from "../interfaces/administration/picklistValuesData";
import { PicklistItem } from "../shared/picklist/picklist-select.component";
import { ILoggedUserData } from "../interfaces/common/loggedUserData";
import { LoggedUserService } from "../services/common/logged-user.service";

@Component({
  selector: "app-ert-firedepartment-bc-turnover-create",
  templateUrl: "./ert-firedepartment-bc-turnover-create.component.html",
  styles: [
    `
      .button-container {
        display: flex;
        justify-content: space-between;
      }
    `,
  ],
})
export class ERTFiredepartmentBcTurnoverCreateComponent implements OnInit {
  turnoverForm: FormGroup;
  title: string = "Create new Fire Department BC Turnover";
  subCategory: { id: string; text: string }[] = [
    { id: "0", text: "Pump" },
    { id: "1", text: "Leak" },
  ];

  pumpStatus: PumpStatus;

  selectedShiftItem!: PicklistItem;
  selectedCrewItem!: PicklistItem;
  selectedCategoryItem!: PicklistItem;
  selectedPumpItem!: PicklistItem;

  validationMessages: string[] = [];

  pumpSelected: boolean = false;
  pumpLeakSelected: boolean = false;

  currentUser: ILoggedUserData;

  constructor(
    private fb: FormBuilder,
    private pickListsService: PicklistService,
    private router: Router,
    private fireDepartmentsBcTurnoversService: FireDepartmentsBcTurnoversService,
    private loggedUserService: LoggedUserService
  ) {
    this.turnoverForm = this.fb.group({
      category: ["-1", Validators.required],
      subCategory: ["-1"],
      crew: ["-1", Validators.required],
      shift: ["-1", Validators.required],
      date: ["", Validators.required],
      pump: ["-1"],
      pumpStatus: ["-1"],
      comments: ["", Validators.required],
    });
  }

  ngOnInit() {
    this.loggedUserService.getLoggedUserData().subscribe(
      (user) => {
        this.currentUser = user;
      },
      (error) => {
        console.error("Error fetching logged user data:", error);
      }
    );
  }

  onShiftSelected(item: PicklistItem) {
    this.selectedShiftItem = item;
  }

  onCrewSelected(item: PicklistItem) {
    this.selectedCrewItem = item;
  }

  onCategorySelected(item: PicklistItem) {
    this.selectedCategoryItem = item;
    const lowerCaseText = item.text.toLowerCase();
    this.pumpLeakSelected =
      lowerCaseText.includes("pump") || lowerCaseText.includes("leak");
  }

  onPumpSelected(item: PicklistItem) {
    this.selectedPumpItem = item;
  }

  cancel() {
    this.router.navigate(["/firedepartment-bc-turnover"]);
  }

  submit() {
    this.validationMessages =
      this.fireDepartmentsBcTurnoversService.validateBcTurnoverForm(
        this.turnoverForm
      );
    if (this.turnoverForm.valid) {
      const shiftValue = this.turnoverForm.get("shift")?.value;
      const shift: IPicklistValuesData = {
        id: shiftValue,
        value: this.selectedShiftItem.text,
        picklistFieldId: this.selectedShiftItem.fieldId,
        facilityId: Number(this.currentUser?.facilityId) || 1,
      };

      const crewValue = this.turnoverForm.get("crew")?.value;
      const crew: IPicklistValuesData = {
        id: crewValue,
        value: this.selectedCrewItem.text,
        picklistFieldId: this.selectedCrewItem.fieldId,
        facilityId: Number(this.currentUser?.facilityId) || 1,
      };

      const categoryValue = this.turnoverForm.get("category")?.value;
      const category: IPicklistValuesData = {
        id: categoryValue,
        value: this.selectedCategoryItem.text,
        picklistFieldId: this.selectedCategoryItem.fieldId,
        facilityId: Number(this.currentUser?.facilityId) || 1,
      };
      const selectedValues: IPicklistValuesData[] = [shift, crew, category];

      const pumpValue = this.turnoverForm.get("pump")?.value;
      let pumpId = 0;

      if (pumpValue && this.selectedPumpItem) {
        const pump: IPicklistValuesData = {
          id: pumpValue,
          value: this.selectedPumpItem.text,
          picklistFieldId: this.selectedPumpItem.fieldId,
          facilityId: Number(this.currentUser?.facilityId) || 0,
        };
        selectedValues.push(pump);
        pumpId = pumpValue;
      }

      const obj: IFireDepartmentBcTurnover = {
        id: 0,
        facilityId: Number(this.currentUser?.facilityId) || 0,
        facilityName: this.currentUser?.facilityName || "",
        facility: undefined,
        createdById: Number(this.currentUser?.id) || 0,

        status: TurnoverStatus.Open,
        turnoverDate: this.turnoverForm.get("date")?.value,
        initialComments: this.turnoverForm.get("comments")?.value,
        resolvedComments: "",
        turnoverCategory: this.turnoverForm.get("category")?.value,
        subCategory: this.turnoverForm.get("subCategory")?.value,
        pumpStatus: this.turnoverForm.get("pumpStatus")?.value,
        crewId: crewValue,
        shiftId: shiftValue,
        categoryId: categoryValue,
        pumpId: pumpId,
        selectedValuesInTurnover: selectedValues,
        category: "",
        shift: "",
        crew: "",
        createdDate: new Date(),
      };

      this.fireDepartmentsBcTurnoversService
        .saveFireDepartmentBcTurnover(obj)
        .subscribe((data) => {
          this.router.navigate([`/firedepartment-bc-turnover/edit/${data.id}`]);
        });
    } else {
      this.turnoverForm.markAllAsTouched();
    }
  }
}
